document.addEventListener("DOMContentLoaded", function(){

     // Currency formatting function
    function formatCurrency(amount) {
        const userCountry = window.Shopify?.country || 'AU';
        const currencyCode = window.Shopify?.currency?.active || 'AUD';
        const userLocale = navigator.language || 'en-AU';

        if (currencyCode === 'AUD') {
        return amount.toLocaleString('en-AU', {
            style: 'currency',
            currency: 'AUD',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });
        } else {
        return amount.toLocaleString(userLocale, {
            style: 'currency',
            currency: currencyCode,
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });
        }
    }

    const allVariants = document.querySelectorAll("input[data-variant-current-price]");
    const selectedVariant = document.querySelector("input[data-variant-current-price]:checked");
    const stickyBarCurrentPriceText = document.querySelector(".sticky-atc__wrapper .sticky-atc__product-price .current-price.original");
    const selectedVariantPrice =  formatCurrency(+selectedVariant?.getAttribute("data-variant-current-price"));
    selectedVariant ? stickyBarCurrentPriceText.textContent = selectedVariantPrice : "";
    const stickyATCButton = document.querySelector("button.sticky-atc");

    // Add listener to the document for changes on inputs
    document.addEventListener("change", function (e) {
        if (e.target.matches('input[data-variant-current-price]')) {
            const selectedVariantPrice = formatCurrency(+e.target.getAttribute("data-variant-current-price"));
            stickyBarCurrentPriceText.textContent = selectedVariantPrice;
            if(e.target.classList.contains("disabled")){
                stickyATCButton.disabled = true;
                stickyATCButton.querySelector("span.sold-out-message").classList.remove("hidden");
                stickyATCButton.querySelector("span").classList.add("hidden");
            }else{
                stickyATCButton.disabled = false;
                stickyATCButton.querySelector("span.sold-out-message").classList.add("hidden");
                stickyATCButton.querySelector("span").classList.remove("hidden");
            }
        }
    });
    document.addEventListener("click", function (e) {
        if (e.target.matches('a.trustspot-inline-write-a-review')) {
            e.preventDefault();

            const currentActiveTab = document.querySelector(".details-item[open]");
            if (currentActiveTab) {
            currentActiveTab.removeAttribute("open");
            }

            const tabSpans = document.querySelectorAll(".details-item summary span");
            let reviewTab = null;

            tabSpans.forEach(span => {
            if (span.textContent.trim().toUpperCase() === "REVIEWS") {
                reviewTab = span.closest("details.details-item");
            }
            });

            if (reviewTab) {
            reviewTab.setAttribute("open", true);
            setTimeout(() => {
                const writeReviewSection = document.querySelector("#trustspot-widget-wrapper");
                if (writeReviewSection) {
                writeReviewSection.scrollIntoView({ behavior: "smooth", block: "start" });
                }
            }, 100);
            }
        }
    });

    const qtyInput = document.querySelector("quantity-input input.quantity__input");
    qtyInput.addEventListener("change", function(e){
        stickyATCButton.setAttribute("data-sticky-atc-qty", +e.target.value);
    })
})